var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user && _vm.user.role === 'admin')?_c('v-container',[_c('v-row',[_c('v-col',[(_vm.$route.name === 'redirect-banks-edit')?_c('redirect-banks-edit-card'):_c('redirect-banks-card')],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }